export class FormAutocomplete {
    selected?= false;
    selecting?= false;
    owned?: any;
}



// WEBPACK FOOTER //
// ./src/app/components/form-autocomplete/form-autocomplete.ts